// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2mWNL","paddedWrapper":"_1VOOS _2mWNL","object":"_3HBgm","objectActive":"_1XrXB _3HBgm","title":"sFyEF","info":"q1AV_","reason":"_4HHUx","conflict":"_2Nz0z _4HHUx","tools":"_2y5B3","heading":"_2TdKm","mainHeading":"_13Dz9 _2TdKm","album":"_1Yceo","albumInfo":"wXLcI","albumThumb":"_1D-aT","albumCount":"_1fAyM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/present/ChannelInfo.css
// module id = 835
// module chunks = 0